<template>
  <component
    class="default-button"
    :class="component_classes"
    :is="is_link ? 'a' : 'button'"
    @click="$emit('click', $event)"
    v-bind="link_data">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "DefaultButton",
  props: {
    href: {
      type: String,
      default: ''
    },
    is_light: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    d_inline_flex: {
      type: Boolean,
      default: false
    },
    dare_colors: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    is_link() {
      return this.href
    },
    component_classes() {
      return {
        light: this.is_light,
        bordered: this.bordered,
        d_inline_flex: this.d_inline_flex,
        dare_colors: this.dare_colors,
      }
    },
    link_data() {
      if (this.is_link) {
        return {
          href: this.href
        }
      }
      return {
        type: 'button'
      }
    }
  }
}
</script>
